// extracted by mini-css-extract-plugin
module.exports = {"a":"Anchor__a___1_Iz8"};